module.exports = __webpack_public_path__ + "img/user_icon.2f4e5f21.svg";